import { useAppSelector } from '../../app/hooks';
import { maxRole } from '../../helpers';
import Link from '../link';
import links from './links';

interface NavProps{
  onNavigate: () => void
}

const Navigation = (props: NavProps) => {
  const { places } = useAppSelector( state => state.places );
  const { notifications } = useAppSelector( state => state.user );
  let my_role = maxRole(places);

  return (
    <nav>
      <div className="nav__label label">Menu</div>
      <ul>
        { links.map((link, index) => my_role >= link.role && <Link key={index} {...link} notifications={(link.to === '/notifications') ? notifications : undefined} onNavigate={props.onNavigate} />) }
      </ul>
    </nav>
  )
}


export default Navigation;